import { FC } from 'react'
import { LayoutHeader } from '@/components/domains/layouts'
import SeoHeader from '@/components/domains/layouts/header/SeoHeader'
import { ListEvents } from '@/components/domains/list'
import ROUTES from '@/constants/legacy/constRoutes'

const PageHomeEvents: FC = () => {
  return (
    <>
      <SeoHeader
        title="이벤트 - 핏펫몰"
        metaDescription="오직 핏펫의 고객님만을 위한 특별한 혜택들을 만나보세요."
        pathname={ROUTES.HOME.EVENTS.BASE}
      />
      <LayoutHeader />
      <ListEvents />
    </>
  )
}

export default PageHomeEvents
